import * as _ from "lodash";
import CreateSiteForm from "./CreateSiteForm";

export interface IValidationError {
    property: string;
    message: string;
}

export class ValidationResult {
    
    isValid: boolean;
    errors: IValidationError[];

    constructor(isValid: boolean, errors: IValidationError[]) {
        this.isValid = isValid;
        this.errors = errors;
    }
    
    public toString(): string {
        return this.errors
            .map((validationError) => `${validationError.property} : ${validationError.message}`)
            .join(", ");
    }
}

export class ValidationUtils
{
    private static requiredPropertiesForCreateSiteForm: string[] = ["tenantId", "schoolCode", "siteName", "menuListName", "menuSiteUrl"];

    public static validateCreateSiteForm(csf: CreateSiteForm)
    {
        if (csf.siteType == "communication") {
            this.requiredPropertiesForCreateSiteForm.push("groups");
        }
        else {
            this.requiredPropertiesForCreateSiteForm.push("users");
        }

        const validate = this.validateObject(csf, this.requiredPropertiesForCreateSiteForm);

        return validate;
    }

    private static validateObject(item: object, requiredProps: string[]) {
        const errors: IValidationError[] = [];
        let isValid = true;

        requiredProps.forEach((requiredPropertyName) => {
            const propVal = _.get(item, requiredPropertyName);

            if (!propVal) {
                isValid = false;
                errors.push({
                    property: requiredPropertyName,
                    message: `${requiredPropertyName} must have a value`
                });
            }
        });

        return new ValidationResult(isValid, errors);
    }

}
